import { OrgType } from 'utils/gloo-types';
import { reloadMe } from 'actions/requests';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { Dispatch, TextReplacer } from './frontendTypes';

export const useThunkDispatch = () => useDispatch<Dispatch>();

export function useMe() {
  return useSelector(({ auth }: RootState) => auth.orgUser);
}

export function useOrg() {
  return useSelector(({ auth }: RootState) => auth.organization);
}

export function useAccessOrgs() {
  return useSelector(({ auth }: RootState) => auth.accessOrgs || []);
}

export function useIsRecovery() {
  const orgType = useSelector(({ auth }: RootState) => auth.organization?.config?.type);
  return { isRecoveryOrganization: orgType === OrgType.RECOVERY };
}

export function useReloadMeOnMount() {
  const dispatch = useThunkDispatch();
  useEffect(() => {
    dispatch(reloadMe());
  }, []);
}

const InsertDataReplacers: TextReplacer[] = [
  { text: 'First Name', replacer: '{{first}}' },
  { text: 'Last Name', replacer: '{{last}}' },
  { text: 'Full Name', replacer: '{{full}}' },
];
const conversationPromptsReplacers = [
  {
    text: 'Email',
    replacer: '[Email]',
  },
  {
    text: 'Full Name',
    replacer: '[Full Name]',
  },
  {
    text: 'First Name',
    replacer: '[First Name]',
  },
  {
    text: 'Last Name',
    replacer: '[Last Name]',
  },
  {
    text: 'Phone Number',
    replacer: '[Phone Number]',
  },
  {
    text: 'Message Type',
    replacer: '[Message Type]',
  },
  {
    text: 'Responder Name',
    replacer: '[Responder Name]',
  },
  {
    text: 'Responder First Name',
    replacer: '[Responder First Name]',
  },
  {
    text: 'Responder Last Name',
    replacer: '[Responder Last Name]',
  },
  {
    text: 'Organization Name',
    replacer: '[Organization Name]',
  },
  {
    text: 'Organization Phone',
    replacer: '[Organization Phone]',
  },
  {
    text: 'Organization Contact Email',
    replacer: '[Organization Contact Email]',
  },
  {
    text: 'Video Link',
    replacer: '[Video Link]',
  },
];
export function useGetTextReplacers(type?: string) {
  if (type === 'Conversation Prompts') {
    return conversationPromptsReplacers;
  }

  const textReplacerArr = [...InsertDataReplacers];
  return textReplacerArr;
}
